import * as types from '../types';
import { IPropertiesApi } from '../contracts';
import { HttpApi } from './HttpApi';

export class PropertiesHttpApi extends HttpApi implements IPropertiesApi {
  async listProperties(customerId?: string, page = 1, limit = 20): Promise<types.PaginatedResponse<types.Property>> {
    const response = await this.http.get<types.PaginatedResponse<types.Property>>(
      '/properties',
      { params: { customerId, page, limit } }
    );
    return response.data;
  }

  async getProperty(id: string): Promise<types.Property> {
    const response = await this.http.get<types.APIResponse<types.Property>>(`/properties/${id}`);
    return response.data.data;
  }

  async getPropertyBalance(id: string): Promise<types.PropertyBalance> {
    const response = await this.http.get<types.APIResponse<types.PropertyBalance>>(`/properties/${id}/balance`);
    return response.data.data;
  }

  async createProperty(data: types.CreatePropertyRequest): Promise<types.Property> {
    const response = await this.http.post<types.APIResponse<types.Property>>('/properties', data);
    return response.data.data;
  }

  async updateProperty(id: string, data: types.UpdatePropertyRequest): Promise<types.Property> {
    const response = await this.http.patch<types.APIResponse<types.Property>>(`/properties/${id}`, data);
    return response.data.data;
  }

  async deleteProperty(id: string): Promise<void> {
    await this.http.delete(`/properties/${id}`);
  }
}
